var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M326.231,178a.953.953,0,0,1-.9-1v-6a.953.953,0,0,1,.9-1h7.179a.953.953,0,0,1,.9,1v1.177l2.076-1.493a.628.628,0,0,1,.368-.117.546.546,0,0,1,.582.5v5.864a.546.546,0,0,1-.582.5.626.626,0,0,1-.368-.117l-2.076-1.493V177a.953.953,0,0,1-.9,1Z",
    transform: "translate(-325.333 -170)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.33ac8e53.svg";
export { ForwardRef as ReactComponent };